import React, { useEffect, useState } from 'react'
import Container from '../ui/comp/Container'
import PageHead from '../components/PageHead'
import { useParams } from 'react-router-dom'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Axios } from '../utils/Axios'
import Loading from '../components/Loading'
import Select from '../ui/comp/Select'
import { CiCalendar } from 'react-icons/ci'
import Status from '../ui/Table/Status'
import { FiUser } from 'react-icons/fi'
import { RiShoppingBag2Line } from 'react-icons/ri'
import TextArea from '../ui/forms/TextArea'
import Td from '../ui/Table/Td'
import Table from '../ui/Table/Table'
import Thead from '../ui/Table/Thead'
import Tbody from '../ui/Table/Tbody'
import Avatar from '../ui/comp/Avatar'
import { displayImage, orderStatus } from '../utils/config'
import FormatCurrency from '../utils/FormatCurrency'

function ViewOrder() {

    const { id } = useParams()
    const queryClient = useQueryClient()

    const [order, setOrder] = useState({})

    const { data, isLoading } = useQuery({
        queryKey: [id],
        queryFn: async () => {
            const res = await Axios.get(`/order/${id}/one`);
            return res.data
        }
    })

    useEffect(() => { setOrder(data || {}) }, [data])

    console.log(data);

    // update status

    const { mutate } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/order/status', formData)
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                predicate: (q) => q.queryKey.includes(id)
            })
        }
    })

    const handleStatus = (id, type) => {
        mutate({ id, type })
    }



    if (isLoading) {
        return (
            <div><Loading /></div>
        )
    }

    return (
        <div className='w-full relative'>

            {/* Head */}
            <PageHead title={"Order Details"} />

            <div className="w-full mt-5">
                <Container>
                    <div className="w-full relative sm:px-7 pb-10">
                        {/* Order ID */}
                        <div>
                            <h1 className="text-lg font-semibold">Order ID: #{order?.orderNumber}</h1>
                        </div>

                        {/* Change Status and data */}
                        <div className="flex flex-col md:flex-row items-center md:justify-between w-full md:items-center mt-5 pb-4 border-b">
                            {/* Date and Status */}
                            <div>
                                <div className='flex text-gray-500 items-center gap-2'>
                                    <CiCalendar strokeWidth={1} size={20} />
                                    <p className="text-sm text-black font-medium">
                                        {new Date(order?.iat).toLocaleString('en-GB', {
                                            month: 'short', day: '2-digit',
                                            year: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
                                        })}
                                    </p>
                                </div>
                                <div className="mt-1 capitalize">
                                    <Status status={order?.status} />
                                </div>
                            </div>

                            {/* Change Status */}
                            <div>
                                <div className='mt-5 w-full'>
                                    <div>
                                        <div className="min-w-40">
                                            <Select classic value={order?.status} onChange={(e) => handleStatus(order?.id, e.target?.value)}>
                                                {orderStatus.map((item, i) => (
                                                    <option value={`${item}`}>{item}</option>
                                                ))}
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        {/*==================================================== Ordeer Customer, Adresss and others ================================================ */}

                        <div className="mt-8 flex flex-col gap-5 lg:flex-row lg:justify-between lg:gap-0">

                            {/* Customer */}
                            <div className="flex gap-3">
                                {/* icon */}
                                <div className="size-14 bg-slate-100 rounded-full flex justify-center items-center">
                                    <FiUser size={25} />
                                </div>
                                <div>
                                    <p className="font-semibold text-[15px] mb-1">Customer</p>
                                    <div className="text-slate-500 text-sm space-y-1 capitalize">
                                        <p>Fullname: {`${order?.User?.firstname} ${order?.User?.lastname}`}</p>
                                        <p>Email: {`${order?.User?.email}`}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Oder Info */}
                            <div className="flex gap-3">
                                {/* icon */}
                                <div className="size-14 bg-slate-100 rounded-full flex justify-center items-center">
                                    <RiShoppingBag2Line size={25} />
                                </div>
                                <div>
                                    <p className="font-semibold text-[15px] mb-1">Order info</p>
                                    <div className="text-slate-500 text-sm space-y-1 capitalize">
                                        <p>Pay Method: {order?.payment_mode}</p>
                                        <p>Status: {`${order?.status}`}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Oder Info */}
                            <div className="flex gap-3">
                                {/* icon */}
                                <div className="size-14 bg-slate-100 rounded-full flex justify-center items-center">
                                    <RiShoppingBag2Line size={25} />
                                </div>
                                <div>
                                    {order?.delivery_type === 'ship' && (
                                        <div>
                                            <p className="font-semibold text-[15px] mb-1">Deliver to</p>
                                            <div className="text-slate-500 text-sm space-y-1 capitalize w-full">
                                                <p className='truncate'>Full name: {order?.shippindAddress?.firstname} {order?.shippindAddress?.lastname}</p>
                                                <p>Country: {order?.shippindAddress?.country}</p>
                                                <p>Address: {order?.shippindAddress?.address}</p>
                                                <div className="flex items-center gap-2">
                                                    <p>City: {order?.shippindAddress?.city}</p>
                                                    {order?.shippindAddress?.apartment && <p>Apartment: {order?.shippindAddress?.apartment}</p>}
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    <p>Phone: <a href={`tel:${order?.shippindAddress?.phone}`}>{order?.shippindAddress?.phone}</a></p>
                                                    {order?.shippindAddress?.postal_code && <p>Postal Code: {order?.shippindAddress?.postal_code}</p>}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {order?.delivery_type === "pickup" && (
                                        <div>
                                            <p className="font-semibold text-[15px] mb-1">Pickup</p>
                                            <div className="text-slate-500 text-sm space-y-1 capitalize w-full">
                                                <p>Location: {order?.pickup_location?.name}</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>


                        {/*====================================== order note  ================================================= */}

                        <div className="w-full pb-5 border-b mt-2">
                            <div className="max-w-lg">
                                <p className="font-semibold text-[15px] mb-1">Order Note</p>
                                <TextArea disabled value={order?.note || "No order note"} />
                            </div>
                        </div>


                        {/* =============================================== Order Items ============================================ */}
                        <div className='w-full relative mt-7 pb-5 border-b'>
                            {order?.order_items?.length && (
                                <div className="space-y-2">

                                    <h1 className="text-xl font-bold text-gray-900 capitalize pl-3">Products</h1>

                                    <Table>
                                        <Thead>
                                            <Td>Product Name</Td>
                                            <Td>Price</Td>
                                            <Td>Quantity</Td>
                                            <Td>Total</Td>
                                        </Thead>

                                        <Tbody>
                                            {order?.order_items?.map((item, i) => (
                                                <tr key={i}>
                                                    <Td>
                                                        <div className="flex gap-2 items-center">
                                                            <Avatar size="lg" src={displayImage(JSON.parse(item?.Product?.images)[0])} />
                                                            <div>
                                                                {item?.Product?.name}
                                                                <div className="text-sm font-normal text-gray-500 flex items-center gap-2">
                                                                    {item?.variant?.size}
                                                                    {item?.variant?.color}
                                                                    {item?.variant?.material}
                                                                    {item?.variant?.type}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Td>

                                                    <Td><FormatCurrency amount={item?.price} /></Td>
                                                    <Td>{item?.quantity}</Td>
                                                    <Td><FormatCurrency amount={item?.price * item?.quantity} /></Td>
                                                </tr>
                                            ))}
                                        </Tbody>
                                    </Table>
                                </div>
                            )}
                        </div>


                        {/* Subtotal and Orders */}

                        <div className="flex lg:flex-row md:flex-row flex-col justify-between w-full mt-8">
                            <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                                <span className="mb-1 font-bold text-sm uppercase text-gray-600 dark:text-gray-500 block">
                                    PAYMENT METHOD
                                </span>
                                <span className="text-sm text-gray-500 dark:text-gray-400 font-semibold block">
                                    {order?.payment_mode}
                                </span>
                            </div>
                            <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                                <span className="mb-1 font-bold text-sm uppercase text-gray-600 dark:text-gray-500 block">
                                    SHIPPING COST
                                </span>
                                <span className="text-sm text-gray-500 dark:text-gray-400 font-semibold block">
                                    <FormatCurrency amount={order?.shipping} />
                                </span>
                            </div>
                            <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                                <span className="mb-1 font-bold text-sm uppercase text-gray-600 dark:text-gray-500 block">
                                    DISCOUNT
                                </span>
                                <span className="text-sm text-gray-500 dark:text-gray-400 font-semibold block">
                                    <FormatCurrency amount={order?.discount} />
                                </span>
                            </div>
                            <div className="flex flex-col sm:flex-wrap">
                                <span className="mb-1 font-bold text-sm uppercase text-gray-600 dark:text-gray-500 block">
                                    TOTAL AMOUNT
                                </span>
                                <span className="text-xl font-bold text-red-500 dark:text-emerald-500 block">
                                    <FormatCurrency amount={order?.total} />
                                </span>
                            </div>
                        </div>

                    </div>
                </Container>
            </div >
        </div >
    )
}

export default ViewOrder